<div class="legend">
  <span class="legend-item">
    <gc-icon [iconName]="'house'" [color]="'primary'" />
    <gc-text [variant]="'paragraph'">{{
      'installationReportingMduTable.legend.building' | translate
    }}</gc-text>
  </span>
  <span class="legend-item">
    <gc-icon [iconName]="'plugConnected'" [color]="'primary'" />
    <gc-text [variant]="'paragraph'">{{
      'installationReportingMduTable.legend.deliveryPoint' | translate
    }}</gc-text>
  </span>
</div>

<gc-table
  [tableColumns]="
    tableColumns() | translateArray: (language$ | async)! : 'headerText'
  "
  [tableRows]="tableRows()"
  [cellTemplates]="cellTemplates()"
  [selectableRows]="true"
  (rowClicked)="onRowClicked($event)"
/>

<ng-template #latestStatusTemplate let-item>
  <ng-container
    *ngTemplateOutlet="
      isDeliveryPortalFI() ? orderStatusTemplate : constructionStatusTemplate;
      context: { $implicit: item }
    "
  />
</ng-template>

<ng-template #orderStatusTemplate let-item>
  <app-status-table-cell
    [status]="item.orderStatus"
    [styleMap]="orderStatusStyling"
    [firstLine]="item.orderStatus | translate"
  />
</ng-template>

<ng-template #constructionStatusTemplate let-item>
  @if (item.constructionStatus) {
    <app-status-table-cell
      [status]="item.constructionStatus"
      [styleMap]="constructionStatusStyling"
      [firstLine]="
        'installationReportingMduTable.constructionStatus.' +
          item.constructionStatus | translate
      "
    />
  }
</ng-template>

<ng-template #deliveryPointsTemplate let-count>
  <div
    class="progress-line"
    [class.done]="count.total > 0 && count.done >= count.total"
  >
    <gc-icon [iconName]="'plugConnected'" [color]="'primary'" />
    <gc-text [variant]="'paragraph'">
      {{ count.done }}/{{ count.total }}
    </gc-text>
  </div>
</ng-template>

<ng-template #sectionStatusTemplate let-section>
  <div class="progress-cell">
    @for (line of sectionProgressLines(section); track line.icon) {
      <div class="progress-line" [class]="line.tone">
        <gc-icon
          [iconName]="line.icon"
          [color]="
            line.tone === 'done'
              ? 'success'
              : line.tone === 'none'
                ? 'disabled'
                : 'primary'
          "
        />

        <gc-text
          [variant]="'paragraph'"
          [textColor]="
            line.tone === 'done'
              ? 'success'
              : line.tone === 'none'
                ? 'secondary'
                : 'primary'
          "
        >
          {{ line.text }}
        </gc-text>
      </div>
    }
  </div>
</ng-template>
